import Header from "../components/Header";

const MaintenanceInfo = () => {
  return (
    <>
      <div className="min-h-screen bg-background-dark flex flex-col p-4 font-sans antialiased">
        <Header />
        <div className="max-w-md mx-auto bg-card-background rounded-xl shadow-2xl p-10 text-center font-sans border border-accent-main">
          <div className="text-5xl text-yellow-500 mb-2">&#9888;</div>
          <h2 className="text-3xl font-bold text-yellow-500 mb-4">Scheduled Maintenance</h2>
          <p className="text-lg text-primary-dark mb-6">
            Eternal Locker™ is currently undergoing scheduled maintenance to improve our services and security.<br />
            We apologize for any inconvenience and appreciate your patience.<br />
            Please check back soon!
          </p>
          <p className="text-sm text-primary-dark">For urgent queries, contact <a
            href="mailto:support@eternallocker.com"
            className="text-accent-main underline hover:text-primary-dark"
          >support@eternallocker.com</a></p>
        </div>
      </div>
    </>
  );
};

export default MaintenanceInfo;
